import { DataAttributeDefinitions, provideDataClass } from 'scrivito'

import { DataClassName, PisaDataClassEndpoint } from '@/Data/const'
import { createPisaRestApiConfig } from '@/Data/pisaClient'

const timerecordPositionDataClassName = DataClassName.TIMERECORD_POSITION
const timerecordPositionEndpoint = PisaDataClassEndpoint.TIMERECORD_POSITION

export function pisaTimerecordPositionDataClass(
  attributes: DataAttributeDefinitions,
) {
  return provideDataClass(timerecordPositionDataClassName, {
    title: timerecordPositionDataClassName,
    restApi: createPisaRestApiConfig(timerecordPositionEndpoint),
    attributes,
  })
}
